import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import axios from "axios";
import Popup from "../../components/Popup";
import StyledFSS from "../Registration/styles";
import Header from "../../components/header";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useParams } from "react-router-dom";
import content from "../../includes/content";

const PublicCertificate = () => {
  const { image_id } = useParams();
  const [error, setError] = useState(false);
  const [metaData, setMetaData] = useState({});
  useEffect(() => {
    const getMetaData = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_CERT_IMG}${image_id}.json`
        );
        console.log(data);
        setMetaData(data);
      } catch (err) {
        console.log("err", err);
        setError(true);
      }
    };
    getMetaData();
  }, [image_id]);
  return (
    <React.Fragment>
      {metaData?.title && (
        <Helmet>
          <meta property="og:url" content={metaData?.url} />
          <meta property="og:type" content="website" />
          <meta name="title" property="og:title" content={metaData?.title} />
          <meta
            name="image"
            property="og:image"
            content={metaData?.thumbnail}
          />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="600" />

          <meta
            name="description"
            property="og:description"
            content={metaData?.description}
          />
          <meta name="author" content="Sun West Mortgage Company, LLC" />
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:url" content={metaData?.url} />
          <meta name="twitter:title" content={metaData?.title} />
          <meta name="twitter:description" content={metaData?.description} />
          <meta name="twitter:image" content={metaData?.thumbnail} />
          <meta name="description" content={metaData?.description} />
          <title>{metaData?.title}</title>
        </Helmet>
      )}
      <Header />
      <StyledFSS>
        <Container>
          <Row>
            <Col className="text-space order-2 order-lg-1">
              <h3 className="d-flex justify-content-center align-items-center">
                {content.mainHeadline}
              </h3>
              <h1 className="d-flex justify-content-center align-items-center cert">
                CERTIFICATE
              </h1>
              <p className="awarded d-flex flex-column justify-content-center align-items-center">
                I have been awarded this
                <span className="cert-name">{content.certificateName}</span>
                by Sun West Mortgage Company Inc.
              </p>
            </Col>
          </Row>
          <Row className="d-flex justify-content-center align-items-start">
            <Col lg={8} className=" d-flex justify-content-center mb-5">
              <Image
                fluid
                onError={() => setError(true)}
                src={`${process.env.REACT_APP_CERT_IMG}${image_id}.png`}
              />
            </Col>
          </Row>
        </Container>
      </StyledFSS>
      {error && (
        <Popup
          loading={error}
          modalText={
            <>
              The Certificate you are attempting to view does not exist.
              <br />
              <Link className="goback" to="/">
                Go Back
              </Link>
            </>
          }
          loadError={true}
        />
      )}
    </React.Fragment>
  );
};
export default PublicCertificate;
